//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import addressBox from '@/components/ui/addressBox'
import inputbox from '@/components/ui/inputbox';
import switchbox from '@/components/ui/switchbox';
import buttonbox from '@/components/ui/buttonbox';

export default {
    components: {inputbox,switchbox,buttonbox,addressBox},
    props: ["addData","addrInfo"],
    data(){
        return {
            baidu: {
                show: false,
                handle: null,
            },
            baiduList: [],
            addrDialog: false,
            addrIds: [],
            addrNames: [],
        }
    },
    methods:{

        // 新增，修改地址
        addAddress(){

            const info = this.addrInfo;

            if(info.consignee.length < 1){
                this.$vux.toast.text('收货人姓名不能为空');
                return false;
            }

            if(!common.isMobile(info.phone_mob)){
                this.$vux.toast.text('手机号不正确');
                return false;
            }

            if(info.region_name.length < 5){
                this.$vux.toast.text('省市区选择不正确');
                return false;
            }

            if(info.locate_addr.length < 2){
                this.$vux.toast.text('定位地址填写不正确');
                return false;
            }

            const opts = {
                url: this.addData.type === 'add' ? api.myAddressAdd : api.myAddressMod,
                data: {
                    ...info
                },
                type: this.addData.type === 'add' ? 'post': 'put',
            }
            opts.data.address = info.locate_addr +" | "+ info.address;

            common.query(opts).then(res=>{
                this.addData.show = false;
                this.$emit("onFinish");
            },res=>{
                this.$vux.toast.text(res.message)
            })

        },

        // 关闭时赋地址值， 后台保存的必须是中文地址，
        changeCity(valueObj){

            this.addrNames = valueObj.map(v=>v.label);
            this.addrIds = valueObj.map(v=>v.id);

            this.addrInfo.region_name = this.addrNames.join(" ");
            this.addrInfo.region_id = this.addrIds[2] ? this.addrIds[2].substring(0,6):'';
            this.addrInfo.town_code = this.addrIds[this.addrIds.length-1];

            this.addrDialog = false;
        },

        // 选择一个百度搜索地址
        changeLocate(item){

            this.addrInfo.locate_addr = item.address;
            this.addrInfo.lng = item.location.lng;
            this.addrInfo.lat = item.location.lat;
            this.baidu.show = false;

        },

        // 用户输入延时更新lng,
        changeBaidu(value){

            if(this.addrNames.length<3){
                this.$vux.toast.text('请先选择省市区');
                this.addrInfo.locate_addr = '';
                return;
            }

            clearTimeout(this.baidu.handle);
            this.baidu.handle = setTimeout(()=>{
                this.queryBaiduList();
            },500);
        },

        // baidu接口调用地址 - 【使用jsonp】  - 由于百度的api存在跨域问题，故使用jsonp来解决跨域问题
        queryBaiduList(v){

            // jsonp 回调函数
            window.showLocation = (res)=>{
                this.baiduList = res.result;
            }

            // 删除script节点
            const clearJSONP = document.querySelector(".baiduApi");
            if(clearJSONP){
                clearJSONP.parentNode.removeChild(clearJSONP);
            }

            // 创建script节点
            const opts = {
                url: 'http://api.map.baidu.com/place/v2/suggestion',
                data: {
                    query: this.addrInfo.locate_addr,
                    region: this.addrNames.indexOf('市辖区') >= 0 ? this.addrNames[0] : this.addrNames[1],
                    city_limit: true,
                    output: 'json',
                    callback: 'showLocation',
                    ak: 'S6X0BXERLCz7MGwtACSs0LQPTXMWYEGx',
                },
                type: 'get',
            }


            const createJSONP = document.createElement('script');
                createJSONP.src = opts.url +"?"+ common.urlMerge(opts.data);
                createJSONP.className = 'baiduApi';
                document.body.appendChild(createJSONP);

        },

    },
    mounted(){
        this.addrNames = this.addrInfo.region_name.split(' ');
    },
}




// WEBPACK FOOTER //
// ./src/views/member/editAddress.vue